// menuFilter.ts
import { MenuItem, Role } from "../types/types";

/** 경로 비교시 대소문자/슬래시 차이를 줄이기 위한 정규화 */
const normalize = (s: string) =>
  s.trim().replace(/\/+$/, "").toLowerCase();

/** 읽기 권한이 있는 apiUrl Set 구하기 */
export function buildReadableSet(roles: Role[]): Set<string> {
  const set = new Set<string>();
  for (const r of roles) {
    if (r?.apiUrl && r.isRead === "Y") {
      set.add(normalize(r.apiUrl));
    }
  }
  return set;
}

/** 메뉴를 읽기 권한 기준으로 재귀 필터링 */
export function filterMenuByRoles(menu: MenuItem[], readable: Set<string>): MenuItem[] {
  const result: MenuItem[] = [];

  for (const item of menu) {
    const hasApi = !!item.apiUrl;
    const allowed = hasApi ? readable.has(normalize(item.apiUrl!)) : false;

    // 서브가 있으면 서브 먼저 필터링
    const filteredSub = item.sub ? filterMenuByRoles(item.sub, readable) : undefined;

    // 포함 조건:
    // 1) 단일 메뉴: apiUrl 있고 allowed === true
    // 2) 그룹 메뉴: sub 결과가 1개 이상일 때 (부모는 apiUrl 없어도 됨)
    if ((hasApi && allowed) || (filteredSub && filteredSub.length > 0)) {
      result.push({
        ...item,
        sub: filteredSub, // 단일 메뉴면 undefined 그대로
      });
    }
  }

  return result;
}
